import _isEmpty from 'lodash/isEmpty';
import _cloneDeep from 'lodash/cloneDeep';
import _filter from 'lodash/filter';
import _includes from 'lodash/includes';
import _forEach from 'lodash/forEach';
import _remove from 'lodash/remove';

import {
  ADD_FILTER,
  DELETE_SEARCH_FILTER,
} from '../actions/types';

const initialState = {
  applications: [],
  loading: true,
  query: '',
  publishCode: null,
  unpublishCode: null,
  deleteCode: null,
  duplicateCode: null,
  applicationId: null,
  program: {},
  template: {},
  submission: {},
  answers: [],
  cashnetCodes: [],
  applicationLoading: true,
  submittedApplications: [],
  selectedRows: [],
  appDashboardFilters: {
    filters: {
      trm_application_templates: [],
      trm_form_templates: [],
      programs: [],
      program_range_term_name: [],
      term_statuses: [],
      program_countries: [],
      traveler_info_types: [],
      traveler_info_residency: [],
      traveler_countries_of_citizenship: [],
      financial_aid: [],
      tags: [],
      program_locations: [],
      internal_program_contacts: [],
      authorized_program_orgs: [],
      archived_trm_apps: [],
      school_names: [],
      colleges: [],
      primary_major: [],
      secondary_major: [],
      primary_minor: [],
      secondary_minor: [],
      third_minor: [],
      year_in_school: [],
      grad_year: [],
      honors_statuses: [],
      archived_templates: [],
      questions: [],
      program_types: [],
      is_alternate: false,
      internal_program_administrators: [],
      internal_program_archive_administrators: [],
      authorized_programs: [],
      archived_authorized_programs: [],
    },
  },
  selected_applications: [],
  update_status_response: [],
  update_status_success: null,
  page: 1,
  moreLoading: true,
  searchFilters: [],
  messageSuccess: null,
  accessDenied: null,
};

export default function(state = initialState, action) {
  let loading;
  let prevApplications;
  let prevSearchFilters;

  switch (action.type) {
    
    case ADD_FILTER:
      prevSearchFilters = [...state.searchFilters];
      let added_filter = {
        ...action.payload.search_filter,
        filter: JSON.parse(action.payload.search_filter.filter),
      };
      prevSearchFilters.push(added_filter);
      return {
        ...state,
        searchFilters: prevSearchFilters,
      };
    case DELETE_SEARCH_FILTER:
      prevSearchFilters = [...state.searchFilters];
      prevSearchFilters.splice(prevSearchFilters.findIndex(x => x.id === action.payload.appliedFilterId), 1);
      return {
        ...state,
        searchFilters: prevSearchFilters,
      };
   
    default:
      return state;
  }
}

const updateStatus = (applications, app_id, newStatus) => {
  applications.find(app => {
    if (app.id === app_id) {
      app.status = newStatus;
      return true;
    }
  });
  return applications;
};

const updateApplicationIds = (selected_applications, app_id, status) => {
  if (status) {
    selected_applications.push(app_id);
  } else {
    _remove(selected_applications, x => x == app_id);
  }

  return selected_applications;
};

const updatePaymentState = (_answers = [], payload) => {
  let answers = _cloneDeep(_answers);
  const answerIdx = answers?.findIndex(ans => ans.element_id === payload.element_id);
  if (answerIdx > -1) {
    answers[answerIdx] = payload;
  } else {
    answers.unshift(payload);
  }

  return answers;
}